// Utils
import {
    describeChanges,
    getElementChangeElementTypes,
    getNewBoardTitles,
} from '../../../../../../../../common/notifications/elementChangesUtils';
import { getNotificationElementChangesAsObject } from '../../../../../../../../common/notifications/notificationModelUtils';

export const getNotificationNewBoardTitles = ({ notification }) => {
    const elementChanges = getNotificationElementChangesAsObject(notification);
    return getNewBoardTitles(elementChanges);
};

export const getNotificationElementChangeElementTypes = ({ notification }) => {
    const elementChanges = getNotificationElementChangesAsObject(notification);
    return getElementChangeElementTypes(elementChanges);
};

export const describeNotificationChanges = ({ notification }) => {
    const elementChanges = getNotificationElementChangesAsObject(notification);
    return describeChanges(elementChanges);
};
